export enum ValidatorTypes {
  Invalid = 0,
  Valid = 1,
  Optional = 2,
}
